import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export interface LegendItem {
    key: string
    label: ReactNode
    color: string
    shape?: 'line' | 'rect' | 'dot'
    value?: ReactNode
}

interface LegendProps {
    items: LegendItem[]
    className?: string
}

const Legend = ({ items, className }: LegendProps): ReactNode => {
    return (
        <ul className={cn('flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs text-muted-foreground', className)}>
            {items.map(item => (
                <li key={item.key} className='flex items-center gap-1.5'>
                    {item.shape === 'rect' && <span aria-hidden='true' className='inline-block size-2.5 rounded-[3px]' style={{ background: item.color }} />}
                    {item.shape === 'dot' && <span aria-hidden='true' className='inline-block size-2 rounded-full' style={{ background: item.color }} />}
                    {(!item.shape || item.shape === 'line') && <span aria-hidden='true' className='inline-block h-0.5 w-3.5 rounded-full' style={{ background: item.color }} />}
                    <span>{item.label}</span>
                    {item.value !== undefined && <span className='font-medium tabular-nums text-foreground'>{item.value}</span>}
                </li>
            ))}
        </ul>
    )
}

export default Legend
